import { makeRoute } from '~/utils/route';

export default makeRoute({
	path: '/replay',
	// template: '<replay-route></replay-route>',
	title: 'menu.replay',
	redirectTo:  () => {
		window.location.href = '/front5/replay';
	},
});
